import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import trJson from "./locales/tr.json";
import enJson from "./locales/en.json";

i18n.use(initReactI18next).init({
  resources: {
    en: enJson,
    tr: trJson,
  },
  fallbackLng: "tr",
  lng: "tr",
  supportedLngs: ["tr", "en"],
  load: "languageOnly",
  interpolation: {
    escapeValue: false,
  },
  defaultNS: "translation",
});

export default i18n;
